if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.header = document.querySelector('.header-wrapper');
        this.input = this.querySelector('input[name="language_code"], input[name="locale_code"], input[name="country_code"]');
        this.button = this.querySelector('button.localization-form__select');
        this.panel = this.querySelector('.disclosure__list-wrapper');

        // PUTAOYAO uses direct language submit buttons in the header. In that mode
        // there is intentionally no disclosure button/panel and no JS is needed.
        if (!this.button || !this.panel || !this.input) return;

        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          const willOpen = this.button.getAttribute('aria-expanded') !== 'true';
          this.button.setAttribute('aria-expanded', String(willOpen));
          this.panel.toggleAttribute('hidden', !willOpen);
          if (this.hasAttribute('data-prevent-hide') && this.header) this.header.preventHide = willOpen;
        });

        this.querySelectorAll('a[data-value]').forEach((item) => {
          item.addEventListener('click', (event) => {
            event.preventDefault();
            this.input.value = item.dataset.value || '';
            const form = this.querySelector('form');
            if (form) {
              if (window.pyPageTransition?.submitForm) window.pyPageTransition.submitForm(form);
              else form.submit();
            }
          });
        });

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          this.close();
          this.button.focus();
        });

        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.close();
        });
      }

      close() {
        if (!this.button || !this.panel) return;
        this.button.setAttribute('aria-expanded', 'false');
        this.panel.setAttribute('hidden', '');
        if (this.hasAttribute('data-prevent-hide') && this.header) this.header.preventHide = false;
      }
    }
  );
}
